var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.134 8.464a1.034 1.034 0 0 0-1.463-.018L5.38 9.704a1.146 1.146 0 0 1-.176.172 8.351 8.351 0 0 1 7.113-7.764 8.404 8.404 0 0 1 7.97 3.239.921.921 0 0 0 1.469-1.113A10.244 10.244 0 0 0 12.039.292c-4.855.74-8.442 4.733-8.688 9.583a.42.42 0 0 1-.06-.076L1.912 8.385A1.036 1.036 0 0 0 .43 9.83l3.071 3.15a1.03 1.03 0 0 0 1.462.018l3.152-3.07c.41-.399.418-1.054.019-1.464zm-3.831 2.797a.48.48 0 0 0 .036-.002c-.012.014-.023.014-.036.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.57 11.22L23.5 8.07a1.034 1.034 0 0 0-1.463-.019l-3.152 3.07a1.036 1.036 0 0 0 1.443 1.483l1.293-1.258c.026-.038.087-.095.16-.158a8.353 8.353 0 0 1-7.11 7.7A8.405 8.405 0 0 1 6.7 15.65a.921.921 0 0 0-1.469 1.112 10.244 10.244 0 0 0 9.717 3.946c4.843-.738 8.423-4.714 8.684-9.55a.464.464 0 0 1 .076.093l1.379 1.415a1.035 1.035 0 0 0 1.481-1.446z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.eef58f0d1af1ecccf20378102edcd8c7.svg";
export { ForwardRef as ReactComponent };